import {useEffect, useState} from 'react'
import Sidebar from '../components/Sidebar'
import Header from '../components/Header'


import { API_BASE } from '../config/api'


function EvaluacionList() {
    return (
        <>
        <Sidebar/>
        <main class="main-content">
            <Header/>
            <div class="content-inner container-fluid pb-0" id="page_layout">
                <div class="d-flex justify-content-between align-items-center flex-wrap mb-4 gap-3">
                    <div class="d-flex flex-column">
                        <h3>Lista de Evaluaciones</h3>
                        <p class="text-primary mb-0">Panduit Core</p>
                    </div>
                    
                </div>

                <div class="row">
                    <div class="col-sm-12">
                        <div class="card">
                            <div class="card-header d-flex justify-content-end">
                                {/* <div class="header-title">
                                    <h4 class="card-title">User List</h4>
                                </div> */}

                                <button class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#addVideoModal">
                                    <span class="btn-inner mr-5">
                                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-24"><path d="M12 4V20M20 12H4" stroke="currentColor" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                    </span>
                                    Agregar Evaluación
                                </button>
                            </div>

                            <div class="card-body px-0">
                                <div class="table-responsive">
                                    <table id="user-list-table" class="table table-striped" role="grid" data-toggle="data-table">
                                        <thead>
                                            <tr class="ligth">
                                            <th>Profile</th>
                                            <th>Name</th>
                                            <th>Contact</th>
                                            <th>Email</th>
                                            <th>Country</th>
                                            <th>Status</th>
                                            <th>Company</th>
                                            <th>Join Date</th>
                                            <th style={{ minWidth: '100px' }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                            <td class="text-center"><img class="bg-primary-subtle rounded img-fluid avatar-40 me-3" src="../../assets/images/shapes/01.png" alt="profile" loading="lazy" /></td>
                                            <td>Anna Sthesia</td>
                                            <td>(760) 756 7568</td>
                                            <td>annasthesia@gmail.com</td>
                                            <td>USA</td>
                                            <td><span class="badge bg-primary">Active</span></td>
                                            <td>Acme Corporation</td>
                                            <td>2019/12/01</td>
                                            <td>
                                                <div className="d-flex">
                                                    <button
                                                        type="button"
                                                        className="btn btn-icon btn-info-subtle ms-2"
                                                        id="viewEvaluacionModalLabel"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#viewEvaluacionModal"
                                                    >
                                                        <span className="btn-inner">
                                                            <svg className="icon-32" width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path opacity="0.4" fillRule="evenodd" clipRule="evenodd" d="M17.7366 6.04606C19.4439 7.36388 20.8976 9.29455 21.9415 11.7091C22.0195 11.8924 22.0195 12.1067 21.9415 12.2812C19.8537 17.1103 16.1366 20 12 20H11.9902C7.86341 20 4.14634 17.1103 2.05854 12.2812C1.98049 12.1067 1.98049 11.8924 2.05854 11.7091C4.14634 6.87903 7.86341 4 11.9902 4H12C14.0683 4 16.0293 4.71758 17.7366 6.04606ZM8.09756 12C8.09756 14.1333 9.8439 15.8691 12 15.8691C14.1463 15.8691 15.8927 14.1333 15.8927 12C15.8927 9.85697 14.1463 8.12121 12 8.12121C9.8439 8.12121 8.09756 9.85697 8.09756 12Z" fill="currentColor"></path>
                                                                <path d="M14.4308 11.997C14.4308 13.3255 13.3381 14.4115 12.0015 14.4115C10.6552 14.4115 9.5625 13.3255 9.5625 11.997C9.5625 11.8321 9.58201 11.678 9.61128 11.5228H9.66006C10.743 11.5228 11.621 10.6695 11.6601 9.60184C11.7674 9.58342 11.8845 9.57275 12.0015 9.57275C13.3381 9.57275 14.4308 10.6588 14.4308 11.997Z" fill="currentColor"></path>
                                                            </svg>
                                                        </span>
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className="btn btn-icon btn-warning-subtle ms-2"
                                                        id="editEvaluacionModalLabel"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#editEvaluacionModal"
                                                    >
                                                        <span className="btn-inner">
                                                            <svg
                                                                className="icon-32"
                                                                width="32"
                                                                viewBox="0 0 24 24"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path
                                                                    opacity="0.4"
                                                                    d="M19.9927 18.9534H14.2984C13.7429 18.9534 13.291 19.4124 13.291 19.9767C13.291 20.5422 13.7429 21.0001 14.2984 21.0001H19.9927C20.5483 21.0001 21.0001 20.5422 21.0001 19.9767C21.0001 19.4124 20.5483 18.9534 19.9927 18.9534Z"
                                                                    fill="currentColor"
                                                                ></path>
                                                                <path
                                                                    d="M10.309 6.90385L15.7049 11.2639C15.835 11.3682 15.8573 11.5596 15.7557 11.6929L9.35874 20.0282C8.95662 20.5431 8.36402 20.8344 7.72908 20.8452L4.23696 20.8882C4.05071 20.8903 3.88775 20.7613 3.84542 20.5764L3.05175 17.1258C2.91419 16.4915 3.05175 15.8358 3.45388 15.3306L9.88256 6.95545C9.98627 6.82108 10.1778 6.79743 10.309 6.90385Z"
                                                                    fill="currentColor"
                                                                ></path>
                                                                <path
                                                                    opacity="0.4"
                                                                    d="M18.1208 8.66544L17.0806 9.96401C16.9758 10.0962 16.7874 10.1177 16.6573 10.0124C15.3927 8.98901 12.1545 6.36285 11.2561 5.63509C11.1249 5.52759 11.1069 5.33625 11.2127 5.20295L12.2159 3.95706C13.126 2.78534 14.7133 2.67784 15.9938 3.69906L17.4647 4.87078C18.0679 5.34377 18.47 5.96726 18.6076 6.62299C18.7663 7.3443 18.597 8.0527 18.1208 8.66544Z"
                                                                    fill="currentColor"
                                                                ></path>
                                                            </svg>
                                                        </span>
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className="btn btn-icon btn-danger-subtle ms-2"
                                                    >
                                                        <span className="btn-inner">
                                                            <svg
                                                                className="icon-32"
                                                                width="32"
                                                                viewBox="0 0 24 24"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path
                                                                    opacity="0.4"
                                                                    d="M19.643 9.48851C19.643 9.5565 19.11 16.2973 18.8056 19.1342C18.615 20.8751 17.4927 21.9311 15.8092 21.9611C14.5157 21.9901 13.2494 22.0001 12.0036 22.0001C10.6809 22.0001 9.38741 21.9901 8.13185 21.9611C6.50477 21.9221 5.38147 20.8451 5.20057 19.1342C4.88741 16.2873 4.36418 9.5565 4.35445 9.48851C4.34473 9.28351 4.41086 9.08852 4.54507 8.93053C4.67734 8.78453 4.86796 8.69653 5.06831 8.69653H18.9388C19.1382 8.69653 19.3191 8.78453 19.4621 8.93053C19.5953 9.08852 19.6624 9.28351 19.643 9.48851Z"
                                                                    fill="currentColor"
                                                                ></path>
                                                                <path
                                                                    d="M21 5.97686C21 5.56588 20.6761 5.24389 20.2871 5.24389H17.3714C16.7781 5.24389 16.2627 4.8219 16.1304 4.22692L15.967 3.49795C15.7385 2.61698 14.9498 2 14.0647 2H9.93624C9.0415 2 8.26054 2.61698 8.02323 3.54595L7.87054 4.22792C7.7373 4.8219 7.22185 5.24389 6.62957 5.24389H3.71385C3.32386 5.24389 3 5.56588 3 5.97686V6.35685C3 6.75783 3.32386 7.08982 3.71385 7.08982H20.2871C20.6761 7.08982 21 6.75783 21 6.35685V5.97686Z"
                                                                    fill="currentColor"
                                                                ></path>
                                                            </svg>
                                                        </span>
                                                    </button>
                                                </div>
                                            </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        </>
    )
}

export default EvaluacionList